module.exports = __webpack_public_path__ + "img/logo-long.27ec0a71.png";